import { generateIconNMRFile } from 'screening';
export function updateIconNMR(form) {
    const { experiments, iconNMROptions } = form;
    const { user, name, title, holder, solvent, deleteExistingHolder, autoSubmit, } = iconNMROptions;
    const data = {
        user,
        name,
        title,
        holder,
        experiments: [],
    };
    for (const experiment of experiments) {
        const parameters = [];
        for (const key in experiment.parameters) {
            parameters.push({ label: key, value: experiment.parameters[key] });
        }
        data.experiments.push({
            experiment: experiment.name,
            solvent,
            parameters,
        });
    }
    form.iconNMR = generateIconNMRFile([data], {
        deleteExistingHolder,
        autoSubmit,
    });
}
//# sourceMappingURL=updateIconNMR.js.map